<div class="alert alert-primary bg-black btn-promo" role="alert" *ngIf="loaded && showMobilePromo">
    <h6 align="center" class="pt-2 pb-1"><img src="./assets/img/percent.svg" class="img-fluid ico-title" width="15"> 50% de descuento en las líneas móviles que contrates que tengan menos cuota mensual</h6>
</div>

<div class="container mb-5" *ngIf="loaded || (_realtechnology && _realtechnology.length > 0)">
    <h5 class="title-step-2 animated fadeIn" align="center">
        <img src="./assets/img/package.svg" class="img-fluid ico-title" width="22"> Ofertas para el cliente
    </h5>

    <div class="row animated fadeIn">
        <div align="center" class="col-md-6 offset-md-3" style="margin-top: -30px;" *ngIf="_realtechnology && _realtechnology.length > 0">
            <h6 class="localidad-norm">
                <span *ngIf="_realtechnology.length > 1">
                    Elige tecnología disponible
                </span>
            </h6>

            <div align="center" class="radio-btn-group2 mb-5">
                <div class="radio" *ngFor="let technology of _realtechnology, index as i" [hidden]="_realtechnology.length > 1 && technologies[technology.access] === 'ADSL'">
                    <input id="technology-{{ i }}" type="radio" name="realtechnology" value="{{ i }}" [checked]="i === indexTypeAccessSelected" (click)="selectTypeAccess($event.target.value)"/>
                    <label for="technology-{{ i }}"><b>{{ technologies[technology.access] }}</b></label>
                </div>
            </div>
        </div>

        <div class="col-md-8 offset-md-2" *ngIf="alertTechnology">
            <div class="alert alert-primary bg-black" role="alert">
                <h6 align="center" class="pt-2 pb-1">
                    Estamos trabajando para que pronto tengas {{ technologies[alertTechnology] }} en tu domicilio.
                </h6>
            </div>
        </div>
    </div>

    <div class="row animated fadeIn" *ngIf="_access">
        <div class="col-lg-4 mb-4" *ngFor="let rate of rates">
            <div class="card-tar card-white mb-5 mb-lg-0">
                <div class="card-tar-header">
                    <div class="d-flex justify-content-between align-items-center">
                        <h5 align="center" class="tar-name" *ngIf="!thereIsOffer(rate, 'name')">
                            {{ rate.name }}
                        </h5>
                        <h5 align="center" class="tar-name new-gb" *ngIf="thereIsOffer(rate, 'name')">
                            <b class="verde">{{ rate?.offers[0]?.name }}*</b>
                            <br>
                            <b class="tachado-gb">{{ rate.name }}</b>
                        </h5>
                        <small class="text-muted">
                            <h5 align="center" class="tar-name" *ngIf="!thereIsOffer(rate, 'price')">
                                {{ rate.price }}
                                <span class="eu2">
                                    €/mes
                                </span>
                            </h5>
                            <h5 align="center" class="tar-name new-price" *ngIf="thereIsOffer(rate, 'price')">
                                {{ rate?.offers[0]?.price }}*
                                <span class="eu2">
                                    €/mes
                                </span>
                                <br>
                                <span class="tachado-anterior">
                                    {{ rate.price }} €/mes
                                </span>
                                <span class="badge badge-pill badge-warning white top-card-percent">
                                    50%
                                </span>
                            </h5>
                        </small>
                    </div>
                </div>
                <div class="card-tar-body">
                    <ul class="mb-5" [ngSwitch]="rate.type">
                        <ng-container *ngSwitchCase="['mobile', '4G'].includes(rate.type) ? rate.type : !rate.type">
                            <h5 align="left" class="tar-name-pricing">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title me-1" width="15">
                                <span *ngIf="!thereIsOffer(rate, 'data')">
                                    <b>{{ rate.data }}</b>
                                    de navegación
                                </span>
                                <span *ngIf="thereIsOffer(rate, 'data')">
                                    <b class="tachado me-1">{{ rate.data }}</b>
                                    <b class="verde">{{ rate?.offers[0]?.data }}*</b>
                                    de navegación
                                </span>
                            </h5>
                            <h5 align="left" class="tar-name-pricing">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title me-1" width="15">
                                <span *ngIf="rate.voice && rate.voice != ''"><b>{{ rate.voice }}</b></span>
                                <span *ngIf="rate.sms && rate.sms != ''"> + <b>{{ rate.sms }}</b></span>
                            </h5>
                        </ng-container>

                        <ng-container *ngSwitchCase="['ftth_dir', 'ftth_ind', 'adsl'].includes(rate.type) ? rate.type : !rate.type">
                            <h5 align="left" class="tar-name-pricing">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title me-1" width="15">
                                {{ rate.speed }}
                            </h5>
                            <h5 align="left" class="tar-name-pricing">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title me-1" width="15">
                                <b *ngIf="!thereIsOffer(rate, 'data')">
                                    {{ rate.data }}
                                    <b *ngIf="rate.voice || rate.sms"> + </b>
                                </b>
                                <span *ngIf="thereIsOffer(rate, 'data')">
                                    <b class="tachado me-1">{{ rate.data }}</b>
                                    <b class="verde">{{ rate?.offers[0]?.data }}*</b>
                                    <span *ngIf="rate.voice || rate.sms"> + </span>
                                </span>
                                <span *ngIf="rate.voice && rate.voice != ''"><b>{{ rate.voice }}</b></span>
                                <span *ngIf="rate.sms && rate.sms != ''"> + <b>{{ rate.sms }}</b></span>
                            </h5>
                        </ng-container>

                        <ng-container *ngSwitchDefault>
                            <h5 align="left" class="tar-name-pricing">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title me-1" width="15">
                                {{ rate.speed }}
                            </h5>
                            <h5 align="left" class="tar-name-pricing">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title me-1" width="15">
                                <b *ngIf="!thereIsOffer(rate, 'data')">
                                    {{ rate.data }}
                                    <b *ngIf="rate.voice || rate.sms"> + </b>
                                </b>
                                <span *ngIf="thereIsOffer(rate, 'data')">
                                    <b class="tachado me-1">{{ rate.data }}</b>
                                    <b class="verde">{{ rate?.offers[0]?.data }}*</b>
                                    <span *ngIf="rate.voice || rate.sms"> + </span>
                                </span>
                                <span *ngIf="rate.voice && rate.voice != ''"><b>{{ rate.voice }}</b></span>
                                <span *ngIf="rate.sms && rate.sms != ''"> + <b>{{ rate.sms }}</b></span>
                            </h5>
                        </ng-container>
                    </ul>
                    <div style="margin-top: -15px;">
                        <a class="btn btn-green btn-sm btn-block mb-2" role="button" (click)="selectRate(rate)">Seleccionar</a>
                        <button class="btn btn-grey btn-sm btn-block" *ngIf="(rate.infoDetails && rate.infoDetails.length) || (rate.info_url && rate.info_url !== '')" (click)="evaluateShowMoreInfo(rate)">Más info</button>
                    </div>
                </div>
            </div>
            <span class="localidad-norm" *ngIf="thereIsOffer(rate, 'expired_date')">*Promoción válida hasta: {{ rate.offers[0]?.expired_date | date:'dd/LL/yyyy' }}</span>
        </div>

    </div>

    <button id="submit" type="submit" class="btn btn-black-outline mb-1 col-lg-12" *ngIf="showAdslButton && loaded" (click)="showAdslRate()">
        La fibra es la mejor opción pero si quieres ADSL pincha aquí para ver las ofertas
    </button>
</div>

<div *ngIf="!loaded">
    <h5 align="center" class="tar-name-preload">Encontrando ofertas...</h5>

    <div align="center">
        <img class="" src="./assets/img/spinner.svg" width="30" alt="">
    </div>
</div>
